const cdnjs = {
    "headroom": "https://cdn.jsdelivr.net/npm/headroom.js@0.11.0/dist/headroom.min.js",
    "tinymce": "https://cdn.jsdelivr.net/npm/tinymce@5.4.2/tinymce.min.js",
    "progressbar": "https://cdn.jsdelivr.net/npm/progressbar.js@1.1.0/dist/progressbar.min.js",
    "datepicker": "https://cdn.jsdelivr.net/npm/vanillajs-datepicker@1.1.4/dist/js/datepicker-full.min.js",
    "datepicker_i18n": "https://cdn.jsdelivr.net/npm/vanillajs-datepicker@1.1.4/dist/js/locales/cs.js",
    "pickr": "https://cdn.jsdelivr.net/npm/@simonwep/pickr/dist/pickr.es5.min.js",
    "pickr_css": "https://cdn.jsdelivr.net/npm/@simonwep/pickr/dist/themes/nano.min.css",
    "cleave": "https://cdn.jsdelivr.net/npm/cleave.js@1.6.0/dist/cleave.min.js",
    "fancybox": "https://cdn.jsdelivr.net/npm/@fancyapps/fancybox@3.5.7/dist/jquery.fancybox.min.js",
    "fancybox_css": "https://cdn.jsdelivr.net/npm/@fancyapps/fancybox@3.5.7/dist/jquery.fancybox.min.css",
    "webanimations": "https://cdn.jsdelivr.net/npm/web-animations-js@2.3.2/web-animations.min.js",
    "muuri": "https://cdn.jsdelivr.net/npm/muuri@0.8.0/dist/muuri.min.js",
    "sortable": "https://cdnjs.cloudflare.com/ajax/libs/Sortable/1.13.0/Sortable.min.js",
    "chartist": "https://cdn.jsdelivr.net/npm/chartist@0.11.0/dist/chartist.min.js",
    "chartist_css": "https://cdn.jsdelivr.net/npm/chartist@0.11.0/dist/chartist.min.css",
    "jqtree": "https://cdn.jsdelivr.net/npm/jqtree@1.5.1/tree.jquery.js",
    "jquery": "https://cdn.jsdelivr.net/npm/jquery@3.5.1/dist/jquery.min.js",
    "cash": "https://cdn.jsdelivr.net/npm/cash-dom@8.1.0/dist/cash.min.js",
    "nestable": "https://cdn.jsdelivr.net/npm/nestablejs@0.1.0/dist/nestable.min.js",
    "print": "https://cdn.jsdelivr.net/npm/print-js@1.5.0/dist/print.min.js",
    "chart": "https://cdn.jsdelivr.net/npm/chart.js@2.9.4/dist/Chart.min.js",
};;
let lang = document.documentElement.getAttribute("lang");
let domain = "https://weild.devlogic.cz";
let swup;
let osScrollMain;
let windowScroll = window;
let dynamicControllers = [
    "comp_ui_select",
    "comp_ui_input",
    "comp_ui_input_file",
    "comp_ui_input_tagify",
    "comp_ui_btn",
    "comp_ui_upload",
    "comp_ui_wsw",
    "comp_table"
];

let dynamicActions = [
    [`a[href^="#"]`, "click->lib#anchor"],
    [`.comp_ui_btn, .comp_ui_link`, "click->lib#ripple"],
    ['[data-href]', "click->lib#href"],
    ['[data-href-m]', "click->lib#hrefMobile"],
    ['[data-href-t]', "click->lib#hrefTablet"]
];

const application = Stimulus.Application.start(document.documentElement);

application.getController = (element, identifier) => application.getControllerForElementAndIdentifier(element, identifier);

importScript.used = [];
importScript.loaded = [];

if (window.matchMedia('(display-mode: standalone)').matches) {
    document.documentElement.addEventListener('contextmenu', (e) => {
        if (e.target.nodeName !== "A" && !$(e.target).closest("a").length) {
            e.preventDefault();
            e.stopPropagation();
        } else {
            e.preventDefault();
            e.stopPropagation();

            if (e.target.closest(".comp_ui_dropdown") !== null) {
                return false;
            }

            let href;

            if (e.target.closest("a") !== null) {
                href = e.target.closest("a").getAttribute("href");
            } else {
                href = e.target.getAttribute("href");
            }

            if (document.querySelector(".tippy--invisible") !== null) {
                document.querySelector(".tippy--invisible").remove();
                tippy.hideAll({ duration: 0 });
            }

            document.body.insertAdjacentHTML("beforeend", `<div class="tippy--invisible" style="top:${e.clientY}px; left:${e.clientX}px"></div>`);

            tippy(document.querySelector(".tippy--invisible"), {
                content: `
                <div class="comp_ui_dropdown">
                    <ul class="wrp_ui_list">
                        <li>
                            <a href="${href}" target="_blank" rel="noopener" data-no-swup>
                                <span class="icon icon--earth"></span>
                                <span>Otevřít odkaz v novém okně</span>
                            </a>
                        </li>
                        <li>
                            <button id="tippy--copy" data-copy-href="${href}">
                                <span class="icon icon--copy"></span>
                                <span>Kopírovat adresu odkazu</span>
                            </button>
                        </li>
                    </ul>
                </div>
            `,
                theme: 'light-border',
                placement: "bottom-start",
                interactive: true,
                arrow: false,
                arrowType: 'round',
                animation: "scale",
                flip: true,
                inertia: true,
                distance: 32,
                onShown: function() {
                    let id = document.querySelector("#tippy--copy");

                    id.addEventListener("click", () => {
                        let temp_input = document.createElement('INPUT');

                        document.body.appendChild(temp_input);
                        temp_input.setAttribute('value', id.getAttribute("data-copy-href"));
                        temp_input.select();
                        document.execCommand('copy');
                        document.body.removeChild(temp_input);

                        tippy.hideAll({ duration: 300 });
                    });
                },
                onHide: function(instance){
                    if (document.querySelector(".tippy--invisible") !== null) {
                        document.querySelector(".tippy--invisible").remove();
                    }
                }
            }).show();
        }
    });
}

if ('serviceWorker' in navigator && location.protocol === "https:") {
    window.addEventListener('load', function() {
        if (!document.documentElement.classList.contains("no-sw")) {
            navigator.serviceWorker.register('/sw.js').catch(function(e) {
                console.error('Error during service worker registration:', e);
            });

            let appInstalled = false;

            window.addEventListener('appinstalled', (evt) => {
                appInstalled = true;

                document.documentElement.addEventListener('contextmenu', function (e) {
                    if (e.target.nodeName !== "A" && e.target.closest("a") === null) {
                        e.preventDefault();
                        e.stopPropagation();
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            });

            if (appInstalled === false && localStorage.getItem("pwaState") === "accepted") {
                localStorage.removeItem("pwaState");
            }

            if (localStorage.getItem("pwaState") === null && document.documentElement.classList.toString().match(/(android|ios|iphone|ipad)/) === null) {
                let deferredPrompt;

                window.addEventListener('beforeinstallprompt', (e) => {
                    e.preventDefault();

                    setTimeout(function () {
                        document.documentElement.insertAdjacentHTML("beforeend", `
                            <div class="comp_prompt state--active is--animate">
                                <div class="wrp_comp_text">
                                    <div class="comp_ui_wsw">
                                        <p>Nainstalujte si web jako aplikaci do vašeho zařízení a mějte ho tak vždy při ruce.</p>
                                    </div>
                                </div>
                                <div class="wrp_comp_btn row--flex row--h-8">
                                    <div class="col">
                                        <button class="comp_ui_btn" aria-label="Instalovat jako aplikaci" data-pwa-approve><span>Instalovat jako aplikaci</span></button>
                                    </div>
                                    <div class="col">
                                        <button class="comp_ui_btn type--outline display--auto" aria-label="Neinstalovat aplikaci" data-pwa-disable><span>Ne děkuji</span></button>
                                    </div>
                                </div>
                            </div>
                        `);

                        document.querySelector("[data-pwa-approve]").addEventListener("click", function(){
                            let prompt = document.querySelector(".comp_prompt");
                            deferredPrompt.prompt();

                            deferredPrompt.userChoice.then((choiceResult) => {
                                if (choiceResult.outcome === 'accepted') {

                                    prompt.classList.remove("is--animate");
                                    localStorage.setItem("pwaState", "accepted");

                                    setTimeout(function () {
                                        prompt.remove();
                                    },1000);

                                    deferredPrompt = null;
                                }
                            });
                        });

                        document.querySelector("[data-pwa-disable]").addEventListener("click", function(){
                            let prompt = document.querySelector(".comp_prompt");

                            prompt.classList.remove("is--animate");
                            localStorage.setItem("pwaState", "disabled");

                            setTimeout(function () {
                                prompt.remove();
                            },1000);
                        });

                        deferredPrompt = e;
                    },1500);
                });
            }
        } else {
            navigator.serviceWorker.getRegistrations().then(function(registrations) {
                if (registrations.length > 0) {
                    for(let registration of registrations) {
                        registration.unregister()
                    }
                }
            });
        }
    });
}

if (!document.documentElement.classList.contains("mobile") && typeof OverlayScrollbars !== "undefined") {
    osScrollMain = OverlayScrollbars(document.querySelectorAll("body"), {
        overflowBehavior : {
            x : "hidden",
            y : "scroll"
        },
        scrollbars : {
            autoHide         : "move",
            autoHideDelay    : 800
        }
    });

    windowScroll = osScrollMain.getElements("viewport");
}

function darkTheme(state) {
    let css = document.getElementById("layout_css");
    let href;

    if (state) {
        href = css.href.replace("light", "dark");
        document.documentElement.classList.add("theme-dark");
        document.querySelector('meta[name="theme-color"]').setAttribute("content","#2f3247");
        // ajax post na server s preferencí dark theme
    } else {
        href = css.href.replace("dark", "light");
        document.documentElement.classList.remove("theme-dark");
        document.querySelector('meta[name="theme-color"]').setAttribute("content","#fff");
        // ajax post na server s preferencí light theme
    }

    if (document.getElementById("layout_manifest") != null) {
        let manifest = JSON.parse(document.getElementById("layout_manifest").innerHTML);

        let name = href.substring(href.lastIndexOf("/")+1, href.length);

        if (typeof manifest[`${name.substring(0, name.indexOf("."))}.css`] !== "undefined") {
            css.href = href.replace(name, manifest[`${name.substring(0, name.indexOf("."))}.css`]);
        }
    } else {
        css.href = href;
    }
}

if (window.matchMedia("(prefers-color-scheme: dark)").matches === true && localStorage.getItem("darkTheme") === null) {
    localStorage.setItem("darkTheme", "enabled");
    document.querySelector('meta[name="theme-color"]').setAttribute("content","#2f3247");
    // ajax post na server s preferencí dark theme
} else if (localStorage.getItem("darkTheme") !== "disabled") {
    document.querySelector('meta[name="theme-color"]').setAttribute("content","#2f3247");
}

try {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener("change", function(e) {
        if (localStorage.getItem("darkTheme") !== "disabled") {
            darkTheme(e.matches);
        }
    });
} catch {}


if (document.body.classList.contains("body--preload")) {
    cssLoaded(function () {
        document.body.classList.remove("body--preload");
        setTimeout(function () {
            document.body.classList.add("body--loaded");
        }, 300);
    });
}

if (typeof WebFontConfig === "undefined" && document.querySelector("#layout_manifest") !== null) {
    if (typeof document.fonts !== "undefined") {
        document.fonts.ready.then(function () {
            document.documentElement.classList.add("wf-active");
        });

        setTimeout(() => {
            if (!document.documentElement.classList.contains("wf-active")) {
                document.documentElement.classList.add("wf-active");
            }
        }, 500);
    } else {
        document.documentElement.classList.add("wf-active");
    }
}

if (typeof document.documentElement.style.grid !== 'string') {
    document.documentElement.classList.add("no-grid");
}

window.addEventListener("resize", function(){
    if (document.documentElement.clientWidth > 960) {
        document.querySelector("#layout_nav").removeAttribute("style")
    }
});

document.addEventListener("DOMContentLoaded", () => {
    var hash = window.location.hash.substr(1);
    var row = document.getElementById(hash);

    if (row) {
        row.classList.add('pulsing-row');
    }
});;
function loadControllers(parent, selectors) {
    if (parent !== null) {
        selectors.forEach((selector) => {
            [...parent.getElementsByClassName(selector)].filter((element) => {
                if (element.getAttribute("data-controller") === null) {
                    element.setAttribute("data-controller", element.className.split(" ")[0]);
                }
            });
        });
    }
}

function loadActions(parent, selectors) {
    if (parent !== null) {
        selectors.forEach((selector) => {
            [...parent.querySelectorAll(selector[0])].filter((element) => {
                let attribute = element.getAttribute("data-action");

                if (attribute === null) {
                    element.setAttribute("data-action", selector[1]);
                } else if (attribute.indexOf(selector[1]) === -1) {
                    element.setAttribute("data-action", `${attribute} ${selector[1]}`);
                }
            });
        });
    }
}

function loadStimulus(selector) {
    loadControllers(selector, dynamicControllers);
    loadActions(selector, dynamicActions);
};
function bodyLoaded(callback) {
    if (!document.body.classList.contains("body--loaded")) {
        let wait = setInterval(function(){
            if (document.body.classList.contains("body--loaded")) {
                clearInterval(wait);
                callback();
            }
        },1);
    } else {
        callback();
    }
};
function cssLoaded(callback, timeout) {
    if (document.querySelector("[data-loadcss]") !== null) {
        let wait = setInterval(function () {
            if (getComputedStyle(document.body)["margin-left"] === "0px") {
                clearInterval(wait);
                setTimeout(function () {
                    callback();
                }, timeout);
            }
        }, 1);
    } else {
        setTimeout(function () {
            callback();
        }, timeout);
    }
};
function importScript(url, callback, options) {
    if (typeof url === "string") {
        url = [url];
    }

    if (typeof options === "undefined") {
        options = {};
    }

    if (typeof options.async === "undefined") {
        options.async = false;
    }

    if (typeof options.delay === "undefined" || window.swupActive) {
        options.delay = 0;
    }

    Promise.all(url.map((url) => {
        if (importScript.used.indexOf(url) === -1) {
            importScript.used.push(url);

            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    const script = document.createElement('script');
                    script.onload = resolve;
                    script.onerror = reject;
                    script.async = options.async;
                    script.src = url;
                    document.head.appendChild(script).parentNode.removeChild(script);
                }, options.delay);
            });
        } else {
            return new Promise((resolve) => {
                let interval = setInterval(function () {
                    if (importScript.loaded.includes(url)) {
                        clearInterval(interval);
                        resolve();
                    }
                }, 1);
            });
        }
    })).then(texts => {
        texts.forEach((data, index) => {
            if (typeof data !== "undefined") {
                importScript.loaded.push(url[index]);
            }
        });
    }).then(() => {
        if (callback) {
            callback();
        }
    });
};
const scrollTop = function(element) {
    if (typeof osScrollMain !== "undefined") {
        typeof element === "undefined" && (element = osScrollMain);
        return element.scroll().position.y;
    } else {
        typeof element === "undefined" && (element = window);
        return element.scrollY
    }
};
function LibRipple(element, e) {
    const init = function (container) {
        if (container.querySelector(".lib--ripple-inner") === null) {
            container.insertAdjacentHTML("beforeend", `<div class='lib--ripple-inner'></div>`);
        }

        let ink = container.querySelector(".lib--ripple-inner");

        ink.classList.remove("animation");

        if (ink.clientWidth === 0 && ink.clientHeight === 0) {
            let d = Math.max(element.offsetWidth, element.offsetHeight);

            ink.style["width"] = d + 'px';
            ink.style["height"] = d + 'px';
        }

        let x, y;

        if (container === document.body) {
            x = e.clientX - container.offsetLeft - (ink.clientWidth / 2);
            y = e.clientY - container.offsetTop - (ink.clientHeight / 2);
        } else {
            x = e.pageX - container.getBoundingClientRect().left - (ink.clientWidth / 2);
            y = e.pageY - container.getBoundingClientRect().top - (ink.clientHeight / 2);
        }

        ink.style["top"] = y + 'px';
        ink.style["left"] = x + 'px';
        ink.classList.add("animation");
    };

    if (element.getAttribute("data-action-ripple") === "body") {
        init(document.body);
    } else {
        init(element);
    }
};
const LibNotification = {
    show: (data) => {
        let date = new Date();
        let id = [...document.querySelectorAll(".lib--notification .comp_ui_notification")].length;
        let uid = date.getTime() + date.getMilliseconds() + id;

        if (document.querySelector(".lib--notification") === null) {
            document.body.insertAdjacentHTML("beforeend", `<div class="lib--notification"></div>`);
        }

        document.querySelector(".lib--notification").insertAdjacentHTML("beforeend", `
            <div class="comp_ui_notification state--${data.state}" data-id="${uid}">
                <button class="elm_close icon--close" data-click="hide"></button>
                <div class="wrp_comp_body row--flex">
                    <div class="col">
                        <strong class="elm_title">${data.title ? data.title : ''}</strong>
                    </div>
                    <div class="col">
                        <span class="elm_text">${data.text}</span>
                    </div>
                </div>
            </div>
        `);

        let notification = document.querySelector(`.lib--notification .comp_ui_notification[data-id="${uid}"]`);

        setTimeout(() => {
            notification.querySelector(`[data-click="hide"]`).addEventListener("click", () => LibNotification.hide(uid));
            notification.classList.add("is--animate-in");
            notification.style.display = "block";
        },500*(id/2));

        if (data.autoHide) {
            setTimeout(() => {
                LibNotification.hide(uid);
            },14000*((id+1)/2));
        }
    },
    hide: (uid) => {
        let notification = document.querySelector(`.lib--notification .comp_ui_notification[data-id="${uid}"]`);
        notification.classList.add("is--animate-out");

        setTimeout(() => {
            domSlider.slideUp({element: notification, slideSpeed: 300});

            setTimeout(() => {
                notification.remove();
                if ([...document.querySelectorAll(".lib--notification .comp_ui_notification")].length < 1) {
                    document.querySelector(".lib--notification").remove();
                }
            }, 300);
        },400);
    },
    hideAll: () => {
        [...document.querySelectorAll(".lib--notification .comp_ui_notification")].map((notification) => notification.classList.add("is--animate-out"));

        setTimeout(() => {
            [...document.querySelectorAll(".lib--notification .comp_ui_notification")].map((notification) => domSlider.slideUp({element: notification, slideSpeed: 300}));

            setTimeout(() => document.querySelector(".lib--notification").remove(), 300);
        },400);
    }
};
;
application.register("module_login", class extends Stimulus.Controller {
    form(e) {
        e.preventDefault();
        let element = this.element;
        let form = e.currentTarget;

        // přepsat na ajax

        element.classList.add("is--animated");

        setTimeout(() => {
            document.body.classList.remove("body--loaded")
            document.body.classList.add("body--preload");
            form.submit();
        }, 500);
    }
});;
application.register("comp_ui_input", class extends Stimulus.Controller {
    initialize() {
        let element = this.element;

        this.validateInput(element, false);

        element.addEventListener("change", () => {
            this.validateInput(element, true);
        });

        this.typeNumber(element);

        this.typeTime(element);

        this.typeDatetime(element);

        this.typeColor(element);

        this.typeFile(element);

        this.typeSearch(element);
    }

    validateInput(element, validate) {
        let input = element.querySelectorAll("input, textarea");

        if (typeof input[0] === "undefined") {
            return false
        }

        [...input].map((input) => {
            if (input.outerHTML.match(/(data-no-validate|readonly|hidden|state--invalid)/) === null && validate) {
                element.classList.remove("state--invalid", "state--valid", "state--active");

                if (input.checkValidity()) {
                    element.classList.add("state--valid");
                } else {
                    element.classList.add("state--invalid");
                }
            }

            if (input.value !== "") {
                element.classList.add("state--active");
            }
        })
    }

    typeNumber(element) {
        if (element.querySelector(`[type="number"]`) !== null) {
            // if (element.querySelector(".icon") === null) {
            //     element.insertAdjacentHTML("beforeend", `<span class="icon icon--angle-down" data-action="minus"></span><span class="icon icon--angle-up" data-action="plus"></span>`);
            // }

            // element.querySelector(`[type="number"]`).addEventListener("keydown", (e) => {
            //     if ([46, 8, 9, 27, 13, 190].indexOf(e.keyCode) !== -1 || e.keyCode === 16 || (e.keyCode === 65 && e.ctrlKey === true) || (e.keyCode >= 35 && e.keyCode <= 39)) {
            //         return;
            //     }
            //
            //     if (((e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            //         e.preventDefault();
            //     }
            // });
            //
            // if (element.querySelector(`[data-action]`) !== null) {
            //     element.querySelector(`[data-action="plus"]`).addEventListener("click", () => {
            //         let input = this.element.querySelector("input"),
            //             num = parseInt(input.value) + parseInt(input.getAttribute('data-step'));
            //
            //         if (num <= input.getAttribute('max')) {
            //             input.value = num;
            //             input.dispatchEvent(new Event('change', {'bubbles': true}));
            //         }
            //     });
            //
            //     element.querySelector(`[data-action="minus"]`).addEventListener("click", () => {
            //         let input = this.element.querySelector("input"),
            //             num = parseInt(input.value) - parseInt(input.getAttribute('data-step'));
            //
            //         if (num >= input.getAttribute('min')) {
            //             input.value = num;
            //             input.dispatchEvent(new Event('change', {'bubbles': true}));
            //         }
            //     });
            // }
        }
    }

    typeDatetime(element) {
        let date = element.querySelector(`[type^="date"]`);

        if (date !== null && element.querySelector("[disabled]") === null && !document.documentElement.classList.contains("mobile")) {
            importScript([cdnjs.datepicker, (lang === "en") ? cdnjs.datepicker_i18n : cdnjs.datepicker_i18n.replace("/cs.",`/${lang}.`)], () => {
                let datetime = date.getAttribute("type") === "datetime-local";
                let required = date.getAttribute("required") !== null;
                let placeholder = date.getAttribute("placeholder") !== null;
                let currentDate, currentTime = null;

                date.setAttribute("type", "hidden");
                element.insertAdjacentHTML("beforeend", `<input type="text" inputmode="none" ${required ? 'required': ''} ${placeholder ? 'placeholder': ''}>`);
                element.querySelector(`[type="text"]`).addEventListener("keydown", (e) => e.preventDefault());

                let hidden = element.querySelector(`[type="hidden"]`);

                if (datetime && hidden.value.indexOf(":") !== -1) {
                    hidden.setAttribute("data-time", hidden.value.substr(hidden.value.indexOf(":") - 2, hidden.value.length))
                }

                let datepicker = new Datepicker(element.querySelector(`[type="text"]`), Object.assign({
                    autohide: true,
                    language: lang,
                    minDate: Datepicker.parseDate(hidden.getAttribute("min"),"yyyy-mm-dd"),
                    maxDate: Datepicker.parseDate(hidden.getAttribute("max"),"yyyy-mm-dd"),
                    daysOfWeekDisabled: hidden.dataset.daysOfWeekDisabled ? JSON.parse(hidden.dataset.daysOfWeekDisabled) : [],
                    datesDisabled: hidden.dataset.datesDisabled ? JSON.parse(hidden.dataset.datesDisabled) : [],
                }, JSON.parse(element.getAttribute("data-lib-datepicker"))));

                datepicker.setDate(Datepicker.parseDate(hidden.value,"yyyy-mm-dd"));

                if (datetime && hidden.value) {
                    element.insertAdjacentHTML("afterbegin", `<span class="input" ${placeholder ? 'placeholder': ''}>${datepicker.getDate("dd.mm.yyyy") + " " + hidden.dataset.time}</span>`);
                }

                datepicker.element.addEventListener("changeDate", () => {
                    if (typeof hidden.dataset.time !== "undefined") {
                        hidden.value = datepicker.getDate("yyyy-mm-dd") + "T" + hidden.dataset.time;

                        let value = datepicker.getDate("dd.mm.yyyy") + " " + hidden.dataset.time;

                        if (element.querySelector('.input') === null) {
                            element.insertAdjacentHTML("afterbegin", `<span class="input" ${placeholder ? 'placeholder': ''}>${value}</span>`);
                        } else {
                            element.querySelector('.input').textContent = value;
                        }
                    } else {
                        hidden.value = datepicker.getDate("yyyy-mm-dd");
                    }

                    hidden.dispatchEvent(new Event('change', { 'bubbles': true }));
                });

                datepicker.element.addEventListener("show", (element) => {
                    let footer = element.detail.datepicker.picker.element.querySelector(".datepicker-footer");
                    currentDate = datepicker.getDate("yyyy-mm-dd");

                    this.element.classList.add("state--active");

                    if (footer.querySelector('[type="time"]') === null && datetime) {
                        let time = hidden.dataset.time;

                        if (typeof time === "undefined") {
                            time = new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
                            hidden.setAttribute("data-time", time);
                        }

                        currentTime = time;

                        footer.insertAdjacentHTML("beforeend", `<div class="datepicker-time"><input type="time" value="${time}" aria-label="Text"></div>`);

                        this.typeTime(footer);

                        footer.querySelector(`[type="time"]`).addEventListener("change", (e) => {
                            hidden.setAttribute("data-time", e.target.value);
                        });

                        footer.querySelector(`[type="time"]`).addEventListener("click", (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            e.target.focus();
                        });
                    } else if (datetime) {
                        currentTime = hidden.dataset.time;
                    }
                });

                datepicker.element.addEventListener("hide", (element) => {

                    if (hidden.value === "") {
                        this.element.classList.remove("state--active");
                    }

                    if (datetime) {
                        element.detail.datepicker.picker.element.querySelector(`[type="time"]`).dispatchEvent(new Event('change', { 'bubbles': true }));

                        if (currentDate === datepicker.getDate("yyyy-mm-dd") && currentTime.toString() !== hidden.dataset.time.toString()) {
                            datepicker.element.dispatchEvent(new Event('changeDate', { 'bubbles': true }));
                        }
                    }
                });
            });
        }
    }

    typeTime(element) {
        if (element.querySelector(`[type="time"]`) !== null && element.querySelector(`[type="time"]`).type !== "time") {
            importScript(cdnjs.cleave, () => {
                element.querySelector('[type="time"]').setAttribute("placeholder", "--:--");
                element.querySelector('[type="time"]').classList.add("polyfill");

                if (element.querySelector("label") !== null) {
                    element.querySelector('[type="time"]').classList.add("is--label");
                }

                new Cleave(element.querySelector('[type="time"]'), {
                    time: true,
                    timePattern: ['h', 'm']
                });
            });
        }
    }

    typeColor(element) {
        if (element.querySelector(`[type="color"]`) !== null) {
            element.classList.add("type--color");
            element.querySelector(`[type="color"]`).setAttribute("inputmode", "none");
            element.querySelector(`[type="color"]`).setAttribute("type", "text");
            element.insertAdjacentHTML("afterbegin", `<span class="color"></span>`);
            importStyle(cdnjs.pickr_css);
            importScript(cdnjs.pickr, () => {
                let input = element.querySelector("input");
                input.setAttribute("pattern", "^#?([a-fA-F0-9]{8}|[a-fA-F0-9]{6}|[a-fA-F0-9]{3})$");

                const pickr = new Pickr({
                    el: input,
                    useAsButton: true,
                    theme: 'nano',
                    position: 'bottom-start',
                    components: {
                        preview: true,
                        opacity: true,
                        hue: true,
                        interaction: {
                            hex: true,
                            rgba: true,
                            input: true
                        }
                    }
                }).on('init', pickr => {
                    pickr.setColor(input.value);
                }).on('change', color => {
                    input.value = color.toHEXA().toString();
                    element.querySelector(".color").style["background-color"] = color.toHEXA().toString();
                }).on('hide', pickr => {
                    pickr.applyColor();
                    input.dispatchEvent(new Event('change', { 'bubbles': true }));
                })

                input.addEventListener("change", (e) => {
                    pickr.setColor(e.target.value);
                })
            });

        }
    }

    typeFile(element) {
        if (element.querySelector(`[type="file"]`) !== null) {
            if (!element.classList.contains("type--file")) {
                element.classList.add("type--file");
                element.insertAdjacentHTML("beforeend", `<div class="icon icon--paper-clip">${element.querySelector("input").title}</div><div><div data-placeholder="${element.querySelector("input").placeholder}"></div></div>`);
            }

            element.querySelector(`[type="file"]`).addEventListener("change", (e) => {
                let placeholder = element.querySelector("[data-placeholder]");
                let remove = element.querySelector(`[data-action*="#typeFileRemove"]`);

                if (e.target.files.length === 0) {
                    element.classList.remove("state--active");
                    placeholder.textContent = "";

                    if (remove !== null) {
                        remove.setAttribute("disabled", "");
                    }

                    return false;
                }

                if (e.target.getAttribute("multiple") === null || e.target.files.length === 1) {
                    placeholder.textContent = e.target.value.replace(/.*(\/|\\)/, '');
                } else {
                    let files = e.target.files;
                    placeholder.textContent = `${Object.keys(files).length} soubory`;
                }

                if (e.target.files.length > 0) {
                    element.classList.add("state--active");

                    if (remove !== null) {
                        remove.removeAttribute("disabled");
                    }
                }
            });
        }
    }

    typeFileRemove() {
        this.element.querySelector(`[type="file"]`).value = null;
        this.element.querySelector(`[type="file"]`).dispatchEvent(new Event('change', { 'bubbles': true }));
    }

    typeSearch(element) {
        if (element.classList.contains("type--search")) {
            element.querySelector("input").addEventListener("focus", () => {
                element.classList.add("state--focus");
            });

            element.querySelector("input").addEventListener("blur", (e) => {
                if (e.target.value.length === 0) {
                    element.classList.remove("state--focus");
                }
            });
        }
    }

    typeSearchSubmit(e) {
        if (e.defaultPrevented) {
            return;
        }

        var key = e.key || e.keyCode;

        if (key === 'Enter' || key === 13) {
            e.currentTarget.form.submit();
        }
    }

    typeSearchClear(e) {
        e.currentTarget.closest('form').querySelector('input').value = ''
        e.currentTarget.closest('form').submit();
    }
});
;

loadStimulus(document);

application.register("lib", class extends Stimulus.Controller {
    ripple(e) {
        LibRipple(e.currentTarget, e)
    }
});

application.register("lib-notification", class extends Stimulus.Controller {
    connect() {
        let data = JSON.parse(this.element.getAttribute("data-lib-notification"));

        LibNotification.show({
            autoHide: true,
            state: data['state'],
            title: data['title'],
            text: data['text']
        });
    }
});
